<template>
  <div class="introduction">
    <div class="introduction-banner">
      <img src="@/assets/twoStar/3.jpg" alt />
    </div>
    <div class="introduction-content">
      <div class="introduction-content-title">东坡水街商圈综合党委简介</div>
      <p>
        眉山东坡水街建于2019年，全长2公里，是2021年全省十大网红打卡地，被誉为“大宋不夜城”。东坡水街商圈综合党委成立于2021年，现有党员63名、入党积极分子23名，下设11个党支部，包括餐饮住宿、休闲娱乐、商超零售、教育培训、便民服务5个行业党支部，水街商管、文旅、商企联盟、志愿、眉州东坡、徐氏教育6个党支部。商圈覆盖入驻商家376家、企业6家，商圈及带动周边综合产值2亿元。东坡水街商圈综合党委致力于完善“网红水街”治理功能，整合多方服务力量，推动商圈共建共治、融合发展。
      </p>
      <img src="@/assets/twoStar/dpCommerceIntro.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.introduction {
  &-content {
    p {
      text-indent: 0.4rem;
      color: #333333;
      margin-bottom: 0.2rem;
    }
    &-title {
      font-weight: bold;
      font-size: 0.36rem;
      text-align: center;
      line-height: 3;
    }
    img {
      max-width: 100%;
    }
    position: absolute;
    top: 2.5rem;
    width: 94%;
    left: 3%;
    box-shadow: 0px 0.08rem 0.24rem 0px rgba(0, 0, 0, 0.17);
    border-radius: 0.08rem;
    padding: 0.2rem;
    padding-bottom: .5rem;
  }
  &-banner {
    img {
      width: 100%;
    }
  }
  padding: 1rem 0.2rem 0;
  font-size: 0.3rem;
  background: #fff;
}
</style>